module.exports = __webpack_public_path__ + "static/media/3-2.f7bd7923.mp3";